// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum TrackerConfigType {
	Radar = 0,
	Video = 1,
}

export const TrackerConfigTypeDisplayNames: { [key in keyof typeof TrackerConfigType]?: string} = {
	"Radar": "Radar",
	0 : "Radar",
	"Video": "Video",
	1 : "Video",
}

export const getTrackerConfigTypeDisplayName = (key: TrackerConfigType | (keyof typeof TrackerConfigType & string)) => {
	return TrackerConfigTypeDisplayNames[key];
}

